import { BigNumber, utils } from "ethers";

export const formatEthAccount = (account: string | null) => {
  if (!account) {
    return "Loading...";
  }

  return `${account.substr(0, 4)}•••${account.substr(-4, 4)}`;
};

const usdFormatter = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",
  minimumFractionDigits: 2,
});

const tokensFormatter = new Intl.NumberFormat("en-US", {
  // minimumFractionDigits: 0,
  maximumFractionDigits: 18,
});

export const stripCommas = (num: string) => num.replace(/[^\d.]/g, "");

export const formatNumber = (
  num: BigNumber | number | string,
  round = true
) => {
  if (BigNumber.isBigNumber(num)) {
    num = num.toString();
  }

  num = Number(num);
  if (round) {
    num = Math.round(num);
  }
  return tokensFormatter.format(num);
};

export const formatUSD = (num: BigNumber | number | string, decimals = 2) => {
  if (BigNumber.isBigNumber(num)) {
    num = num.toString();
  }
  return decimals === 2
    ? usdFormatter.format(Number(num))
    : new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD",
        minimumFractionDigits: decimals,
      }).format(Number(num));
};

const stripTrailingZero = (s) => s.replace(/.0$/, "");

export const formatTokens = (num: BigNumber | string, round = true) => {
  if (!round) {
    return stripTrailingZero(utils.commify(utils.formatUnits(num)));
  }
  return formatNumber(utils.formatUnits(num), round);
};

export const toBN = (n: BigNumber | string): BigNumber =>
  typeof n === "string" ? BigNumber.from(n) : n;

export const parseRawTokenFormValue = (val: string) => {
  const bn = BigNumber.from(utils.parseUnits(stripCommas(val || "0")));
  return bn;
};

type Numberish = BigNumber | number | string;

const DECIMALS = BigNumber.from("18");
const DECIMALS_FACTOR = BigNumber.from("10").pow(DECIMALS);

export const toDecimal = (amount: Numberish = 0) => {
  if (!BigNumber.isBigNumber(amount)) {
    amount = BigNumber.from(amount);
  }
  if (amount.isZero()) {
    return BigNumber.from(0);
  }
  return amount.div(DECIMALS_FACTOR);
};
